import * as jsxRuntime from "/builds/rndml/kandinsky-salute/kandinsky-frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment